import Tooltip from "components/Tooltip";
import { IconButton } from "@chakra-ui/react";
import { Icon } from "assets/Icon";
import { ProfileContext } from "context/ProfileContext";
import { useContext } from "react";
import { ReactComponent as ActiveProfileCheck } from "./../../icons/proflie-check.svg";
import { ProfileAvatar } from "components/common/ProfileAvatar/ProfileAvatar";
import ReactTooltip from "react-tooltip";
import { useCurrentCompany } from "hooks/auth";

export const SidebarHeader = ({ isCollapseNav }) => {
	const { changeProfileType, currentProfile, isAccountSwitchable } =
		useContext(ProfileContext);
	const currentCompany = useCurrentCompany();

	const isProcurer = currentProfile === "Procurer";

	const handleSwitchProfile = () => {
		const profileType = isProcurer ? "supplier" : "client";
		changeProfileType(profileType);
	};

	const displayLogo = currentCompany?.logo_path;

	return (
		<div
			style={{
				display: "flex",
				gap: 16,
				alignItems: "center",
				justifyContent: "start",
				margin: isCollapseNav ? "40px 0px 20px 0px" : "40px 8px 20px 12px",
			}}
		>
			{displayLogo && (
				<div>
					<ProfileAvatar
						imagePath={displayLogo}
						className="size-12 p-1 shadow-lg"
					/>
				</div>
			)}
			<div
				id="profile"
				className="overflow-hidden text-ellipsis"
			>
				<h2 className="max-w-xs overflow-hidden truncate text-ellipsis font-roboto text-[30px] font-bold capitalize text-[#101828]">
					{currentCompany?.name}
				</h2>
				<div className="flex items-center gap-6">
					<div className="flex items-center gap-2">
						<p className="uppercase text-[#0031DD]">{currentProfile}</p>
						<ActiveProfileCheck />
					</div>
					{isAccountSwitchable && (
						<Tooltip
							label={`Switch Role to ${isProcurer ? "Bidder" : "Procurer"}`}
						>
							<IconButton
								onClick={handleSwitchProfile}
								icon={<Icon icon="switch-horizontal" />}
								aria-label="Switch Role"
							/>
						</Tooltip>
					)}
				</div>
			</div>

			<ReactTooltip effect="solid" />
		</div>
	);
};

export default SidebarHeader;
